module.exports = __webpack_public_path__ + "img/account-icon.4870ee3f.svg";